import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { catchError, map } from 'rxjs/operators';
import { of, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class FileService {
  constructor(private http: HttpClient) { }

  checkFileExists(url: string): Observable<boolean> {
    return this.http.get(url, { responseType: 'text', observe: 'response' }).pipe(
      map(response => response.status === 200), // Retorna true apenas se o status for 200
      catchError(error => of(false)) // Se for erro (404 ou outro), retorna false
    );
  }
}
